import type { StoreInfoDto } from "../types/store.dto";

const EARTH_RADIUS_KM = 6371;
const RAD_FACTOR = Math.PI / 180;

const toRad = (deg: number) => deg * RAD_FACTOR;

/** Distância aproximada (km) entre dois pontos — Haversine. */
export function distanceKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(a));
}

/** Loja com coordenada cadastrada (`lat`/`lon` chegam como string, e podem vir vazios). */
export function hasCoordinates(store: StoreInfoDto): boolean {
    return Number.isFinite(Number(store.latitude)) && Number.isFinite(Number(store.longitude))
        && store.latitude !== "" && store.longitude !== "";
}

/** Loja mais próxima do ponto, ignorando as sem coordenada. `null` quando nenhuma tem. */
export function nearestStore(
    stores: StoreInfoDto[],
    lat: number,
    lon: number
): { store: StoreInfoDto; distanceKm: number } | null {
    let best: { store: StoreInfoDto; distanceKm: number } | null = null;
    for (const store of stores) {
        if (!hasCoordinates(store)) continue;
        const dist = distanceKm(lat, lon, Number(store.latitude), Number(store.longitude));
        if (!best || dist < best.distanceKm) best = { store, distanceKm: dist };
    }
    return best;
}
